<template>
    <div id="index_news_container">
        <div id="news_title">最近新闻</div>
        <div id="news_container">
            <ul id="news_view_ul">
                <li v-for="(item, index) in news" v-bind:key="item">
                    <a class="new_open_url" :href="item.URL_VIEW" :title="item.TITLE" target="_blank">
                        <span class="news_rows">{{ index + 1 }}.</span>
                        <span class="news_title">{{ item.TITLE }}</span>
                        <span class="news_time">{{ item.PUBLISH_TIME }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import gConfig from '../gConfig';

export default {
    name: 'News1',
    data() {
        return {
            news: [{ PUBLISH_TIME: 'loading', URL_VIEW: 'loading', TITLE: 'loading' }]
        }
    },
    methods: {
        init: function () {
            var self = this;
            axios.post(gConfig.web_pc + '/home/IndexMain/Index_NewsToday_List', {
                firstName: 'Fred',
                lastName: 'Flintstone'
            }).then(function (response) {
                self.news = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    mounted: function () {
        this.init();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/News1.vue